enum Regions {
  EU = "eu-west-1",
  US = "us-west-2"
}

export default Regions
